import React from 'react';
import { motion } from 'framer-motion';

const experiences = [
  {
    label: 'For the Pamilya',
    title: 'A weekend the kids will remember',
    desc: 'Bonding sa pond, beginner lessons para sa mga bata, at picnic-friendly cabanas with shaded views.',
    img: 'https://images.unsplash.com/photo-1603367563698-67012943fd67?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwxfHxhc2lhbiUyMGZhbWlseSUyMG91dGRvb3IlMjBuYXR1cmV8ZW58MHx8fHwxNzgxMzI2OTkzfDA&ixlib=rb-4.1.0&q=85',
    span: 'md:col-span-7 md:row-span-2',
    testid: 'exp-family',
  },
  {
    label: 'For the Barkada',
    title: 'Group lakwatsa, served slow',
    desc: 'Cabana rentals, BBQ packages, at all-day fishing. Perfect for team outings o reunions.',
    img: 'https://images.pexels.com/photos/8491086/pexels-photo-8491086.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    span: 'md:col-span-5',
    testid: 'exp-barkada',
  },
  {
    label: 'For the Solo Soul',
    title: 'Pahinga, hindi pagmamadali',
    desc: 'Half-day or full-day fishing, journal-worthy mornings, at quiet shoreline reflection.',
    img: 'https://images.unsplash.com/photo-1533037932350-a08bba6019f6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHw0fHxmaXNoaW5nJTIwcG9uZCUyMG5hdHVyZXxlbnwwfHx8fDE3ODEzMjY5OTN8MA&ixlib=rb-4.1.0&q=85',
    span: 'md:col-span-5',
    testid: 'exp-solo',
  },
  {
    label: 'For the Learner',
    title: 'Learn-to-Fish with a guide',
    desc: 'Beginner-friendly session — rods, bait, technique. Sulit kahit first-timer ka pa.',
    img: 'https://images.unsplash.com/photo-1588676509970-63fe490c3712?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwzfHxmaXNoaW5nJTIwcG9uZCUyMG5hdHVyZXxlbnwwfHx8fDE3ODEzMjY5OTN8MA&ixlib=rb-4.1.0&q=85',
    span: 'md:col-span-7',
    testid: 'exp-learn',
  },
];

export default function Experiences() {
  return (
    <section
      id="experiences"
      data-testid="experiences-section"
      className="py-20 md:py-32 bg-sand"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12 md:mb-16">
          <div className="max-w-2xl">
            <p className="overline text-muted mb-4">Choose your Asana</p>
            <h2 className="editorial-display text-pond text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
              Bawat dating ay may sariling kuwento.
            </h2>
          </div>
          <p className="text-muted md:max-w-sm text-base md:text-lg">
            Pick the experience that fits your day — kahit anong pace, kahit anong company.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-5 md:gap-6 md:auto-rows-[280px]">
          {experiences.map((e, i) => (
            <motion.a
              key={e.title}
              href="#book"
              data-testid={e.testid}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-80px' }}
              transition={{ duration: 0.7, delay: i * 0.08, ease: 'easeOut' }}
              className={`group relative overflow-hidden rounded-[28px] border border-moss/20 col-span-1 ${e.span} min-h-[280px]`}
            >
              <div
                className="absolute inset-0 bg-cover bg-center transition-transform duration-[1200ms] group-hover:scale-105"
                style={{ backgroundImage: `url(${e.img})` }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-pond/85 via-pond/30 to-transparent" />
              <div className="relative h-full flex flex-col justify-end p-6 md:p-8 text-offwhite">
                <p className="overline text-sky/90 mb-2">{e.label}</p>
                <h3 className="editorial-display text-2xl md:text-3xl leading-tight">
                  {e.title}
                </h3>
                <p className="mt-2 text-offwhite/85 text-sm md:text-base max-w-md">
                  {e.desc}
                </p>
                <span className="mt-4 inline-flex items-center gap-2 text-sm font-medium text-sky group-hover:text-offwhite transition-colors">
                  Plan this visit
                  <span className="transition-transform group-hover:translate-x-1">→</span>
                </span>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
